import React, { useEffect } from "react";
import { X, Phone } from "lucide-react";
import { WeeklyHours, RestaurantAddressLink } from "./RestaurantOperationalInfo";

/** Public restaurant information: status, phone, address and the full weekly schedule. */
export default function RestaurantInfoSheet({ open, onClose, restaurant, locale = "sr", t = (k, d) => d }) {
  useEffect(() => {
    if (!open) return;
    const y = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${y}px`;
    document.body.style.width = "100%";
    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, y);
    };
  }, [open]);

  if (!open || !restaurant) return null;
  const phone = (restaurant.phone || "").trim();

  return (
    <div className="fixed inset-0 z-[70] max-w-md mx-auto flex items-end" data-testid="restaurant-info-sheet">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full bg-white rounded-t-3xl max-h-[85vh] flex flex-col animate-slide-up">
        <div className="flex items-start justify-between px-5 pt-5 pb-3 border-b">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.16em] text-slate-400">
              {t("info.title", "Informacije o restoranu")}
            </p>
            <h2 className="font-display font-black text-xl mt-0.5">{restaurant.name}</h2>
          </div>
          <button data-testid="info-close" aria-label={t("common.close", "Zatvori")} onClick={onClose}
            className="w-11 h-11 -mt-1 -mr-1 shrink-0 flex items-center justify-center rounded-full hover:bg-slate-100">
            <X size={20} />
          </button>
        </div>

        <div className="px-5 py-4 overflow-y-auto space-y-5">
          {phone && (
            <div>
              <h3 className="font-display font-black text-sm uppercase tracking-wider text-slate-400 mb-1">
                {t("info.phone", "Telefon")}
              </h3>
              <a data-testid="info-phone" href={`tel:${phone.replace(/\s+/g, "")}`}
                className="inline-flex items-center gap-2 text-brand-red font-bold text-base">
                <Phone size={16} /> {phone}
              </a>
            </div>
          )}

          <div>
            <h3 className="font-display font-black text-sm uppercase tracking-wider text-slate-400 mb-1">
              {t("info.address", "Adresa")}
            </h3>
            <RestaurantAddressLink restaurant={restaurant} locale={locale} />
          </div>

          <WeeklyHours restaurant={restaurant} locale={locale} t={t} className="border-t pt-4" />
        </div>
      </div>
    </div>
  );
}
